export const DEFAULT_STATUS_REASON = [
  'DECEASED',
  'COMPANY_EMPLOYEE',
  'PARTIAL_FRAUD',
  'FRAUD',
  'MEMBER_REQUEST',
  'NEW_CLUB_MIGRATION',
  'COMPANY_RESELLER',
  'REGION_CHANGE',
  'UNINFORMED',
  'PRE_MIGRATION',
  'INVALID_DATA',
  'FRAUD_THIRD_LINKED',
  'UNBLOCK_BLOCKLIST',
  'NEW_TELEPHONE_MIGRATION'
]
